import React from "react";
import _ from "lodash";
import {CommonSubmitButton, LoaderType, RenderForm, showNotification, SwitchLoader} from "../../../common";
import { useHistory } from "react-router-dom";
import {PopupModel} from "../../../model";
import {IState} from "../Data";
import { PopupService} from "../../../services";

export const CreateForm = (props: IState) => {
  let history = useHistory();
  const [form, setForm] = React.useState({} as PopupModel);

  const handleChange = (event: React.ChangeEvent<HTMLElement>) => {
    const target : any = event.target;
    const {name, value} = target;
    setForm({...form, [name]: value})
  }

  React.useEffect(() => {
    setForm(props.form)
  },[props.form])


    const FormInputs = [
      {
        "name" : "title",
        "value" : _.get(form, "title", ""),
        "onChange": handleChange,
        "required": true,
        "placeholder": "Enter title",
        "label": "Title",
      },
    ];

    function isDisable() {
      const fields = FormInputs.reduce((acc, val) => acc ? acc : val.value === "" && val.required, false);
      return fields;
    }

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    SwitchLoader(LoaderType.BUTTON);

    if(props.id ){
      PopupService.update(form, props.id).then((message) => {
        showNotification("success", message);
        history.push(`/quiz/popups`)
      }).catch(() => {});
    } else {
      PopupService.store(form).then((message) => {
        showNotification("success", message);
        history.push(`/quiz/popups`)
      }).catch(() => {});
    }
  }

  return(
      <form className="kt-form" id={'customer_form'} onSubmit={handleSubmit}>
        <div className="kt-portlet__body">
          <div className={'row'}>
            <RenderForm items={FormInputs}/>
          </div>
        </div>
        <CommonSubmitButton disabled={isDisable()}/>
      </form>
    )
}
